import React from "react";

const holder = {
  closeDropdown(e) {
    if (holder.containerRef && !holder.containerRef.current?.contains(e.target)) {
      holder.internalStateSetter({ isOpen: false });
      document.removeEventListener("mousedown", holder.closeDropdown)
    }
  }
};

const historyHolder = {
  closeDropdown(e) {
    if (historyHolder.containerRef && !historyHolder.containerRef.current?.contains(e.target)) {
      historyHolder.internalStateSetter({ isOpenHistory: false });
      document.removeEventListener("mousedown", historyHolder.closeDropdown)
    }
  }
};

export default {
  'TimeTrackerRow.ButtonWrapper.ButtonsWrapper.Edit': async ({ containerRef, isOpen }, _, internalStateSetter) => {
    if (isOpen) return;
    await internalStateSetter('isOpen', true);

    let newContainerRef = containerRef;

    if (!containerRef) {
      newContainerRef = React.createRef(null);
      await internalStateSetter({ containerRef: newContainerRef });
    }
    newContainerRef?.current?.scrollIntoView({ behavior: "smooth" });

    holder.internalStateSetter = internalStateSetter;
    holder.containerRef = newContainerRef;
    document.addEventListener("mousedown", holder.closeDropdown);
  },
  'TimeTrackerRow.ButtonWrapper': async ({ historyContainerRef, isOpenHistory }, _, internalStateSetter) => {
    if (isOpenHistory) return;
    await internalStateSetter('isOpenHistory', true);

    let newContainerRef = historyContainerRef;

    if (!historyContainerRef) {
      newContainerRef = React.createRef(null);
      await internalStateSetter({ historyContainerRef: newContainerRef });
    }
    newContainerRef?.current?.scrollIntoView({ behavior: "smooth" });

    historyHolder.internalStateSetter = internalStateSetter;
    historyHolder.containerRef = newContainerRef;
    document.addEventListener("mousedown", historyHolder.closeDropdown);
  },
  'TimeTrackerRow.ButtonWrapper.ButtonsWrapper.History': async ({ historyContainerRef, isOpenHistory }, _, internalStateSetter) => {
    if (isOpenHistory) return;
    await internalStateSetter('isOpenHistory', true);

    let newContainerRef = historyContainerRef;

    if (!historyContainerRef) {
      newContainerRef = React.createRef(null);
      await internalStateSetter({ historyContainerRef: newContainerRef });
    }
    newContainerRef?.current?.scrollIntoView({ behavior: "smooth" });

    historyHolder.internalStateSetter = internalStateSetter;
    historyHolder.containerRef = newContainerRef;
    document.addEventListener("mousedown", historyHolder.closeDropdown);
  },
  'TimeTrackerRow.ButtonWrapper.ButtonsWrapper.Delete': ({ event }, outlet) => {
    outlet({ action: 'delete' })
  },

  'TimeTrackerRow.Dropdown': ({ startDate, endDate, action }, outlet, internalStateSetter) => {
    if (action === 'save') {
      outlet({ startDate, endDate, action })
    }
    internalStateSetter({ isOpen: false })
  }
}
